import React, { FC, useContext } from "react";

import { css } from "@emotion/react";

import { DiscountProgressBarContext } from "../../context";
import { BreakpointProps } from "../types";

export const CompletedBreakpoint5: FC<BreakpointProps> = () => {
  const { theme } = useContext(DiscountProgressBarContext);

  const circleClass = css`
    fill: ${theme.breakpoint.activeColor};
    stroke: ${theme.breakpoint.activeColor};
  `;

  return (
    <span className="ig-dp-completed-breakpoint filled">
      <svg width="16px" height="16px">
        <circle cx="8" cy="8" r="7" css={circleClass} />
      </svg>
    </span>
  );
};
